import React from "react";
import DataTable from "react-data-table-component-with-filter";
import {
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../Helper/Constants";

const AdvanceInvPaymentdetails = ({ invCols, tableData, advanceData }) => {
  return (
    <div>
      <div className="theme-blue border border-1 rounded-2 p-2 ">
        {/* <div className="text-center f"><h3>Current Statement Amount</h3></div> */}
        <div className="row">
          <div className="col my-2 ">
            <div className="fw-bold">
              Total Advance Amount :{" RM "}
              <span className="font-18">
                {" "}
                {advanceData?.amount?.toFixed(2)}
              </span>
            </div>
          </div>
          <div className="col my-2 ">
            <div className="fw-bold">
              Total Invoice Amt. :{" RM "}
              <span className="font-18">
                {" "}
                {!!advanceData?.inv_amt
                  ? advanceData?.inv_amt?.toFixed(2)
                  : "0.00"}
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col my-2 ">
            <div className="fw-bold">
              Utilized Advance Amount :{" RM "}
              <span className="font-18">
                {" "}
                {!!advanceData?.utl_amt
                  ? advanceData?.utl_amt?.toFixed(2)
                  : "0.00"}
              </span>
            </div>
          </div>
          <div className="col my-2 ">
            <div className="fw-bold">
              Balance Advance Amount :
              <span className="font-18">
                {" RM"}
                {!!advanceData?.avl_amount
                  ? advanceData?.avl_amount?.toFixed(2)
                  : "0.00"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12 table-responsive position-relative popup-data-table">
        <DataTable
          columns={invCols}
          data={tableData}
          customStyles={customDataTableStyles}
          pagination
          striped
          highlightOnHover
          paginationRowsPerPageOptions={defaultRowsPerPageOptions}
          paginationPerPage={defaultPageLimit}
        />
      </div>
    </div>
  );
};

export default AdvanceInvPaymentdetails;
